// ES6 polyfill
import 'babel-polyfill';

// requestAnimationFrame polyfill
import 'requestanimationframe';

// Custom modernizr configuration
import './libs/modernizr';

// 99designs global navigation
import createGlobalNav from './components/globalNav';
document.addEventListener('DOMContentLoaded', createGlobalNav);



/** WEBPACK FOOTER **
 ** ./js/common/vendor.js
 **/